// Colores fijos por elemento del Dashboard B2B.
//
// "Pedidos por Grupo", "Pedidos por Familias" y "Pedidos por Marca" asignaban el color por POSICIÓN (1º azul,
// 2º verde...): al filtrar cambiaban el orden y los colores. Ahora, en la carga sin filtro (fetchDashboard) se
// arma un mapa id -> color (state.colorMaps) y las gráficas pintan cada elemento con su color del mapa, filtren
// o no. Grupos y Familias usan el mismo mapa de líneas, así un grupo tiene el mismo color en las 2 gráficas.
// Un elemento que no estaba en la carga sin filtro (ej. una marca que iba dentro de "Otras Marcas") toma un color
// fijo calculado de su id (siempre el mismo).

// Colores de los grupos (líneas), en orden de mayor a menor valor de la carga sin filtro.
export const GROUP_PALETTE = ['#1b7fe5', '#3fc380', '#fd8a2a', '#8965e0', '#f5365c', '#02b0ee', '#febc30', '#3f51b5']

// "Otros" / "Otras líneas" / "Otras familias".
export const OTHERS_COLOR = '#8f9bad'

// Paleta para los colores calculados por id.
const HASH_PALETTE = [
    '#1b7fe5', '#3fc380', '#fd8a2a', '#8965e0', '#f5365c', '#02b0ee', '#febc30', '#3f51b5',
    '#00b8a9', '#e83e8c', '#20c997', '#6f42c1', '#fd7e14', '#17a2b8', '#d63384', '#5e72e4'
]

// Color fijo a partir de una llave (mismo resultado siempre para la misma llave).
export function hashColor(key) {
    const text = String(key)
    let hash = 0

    for (let i = 0; i < text.length; i++) {
        hash = ((hash << 5) - hash + text.charCodeAt(i)) | 0
    }

    return HASH_PALETTE[Math.abs(hash) % HASH_PALETTE.length]
}

// Llave de un grupo (línea) en el mapa: su id, o 'none' para "Sin Línea".
export function lineKey(lineId) {
    return lineId === null || lineId === undefined ? 'none' : String(lineId)
}

// Llave de una marca en el mapa: su id, o el nombre para los recuadros sin id ("Otras Marcas", "Sin Marca").
export function brandKey(brandId, name) {
    return brandId ? String(brandId) : 'name:' + name
}

// Color del mapa o, si no está, el calculado por la llave.
export function colorFor(map, key) {
    return (map && map[key]) || hashColor(key)
}

/**
 * Mapa de colores a partir de las gráficas de la carga sin filtro.
 *
 * @param {Object} charts dashboard.charts
 * @returns {{lines: Object<string, string>, brands: Object<string, string>}}
 */
export function buildColorMaps(charts) {
    const lines = {}
    const brands = {}
    let next = 0

    const addLine = (key) => {
        if (!lines[key]) {
            lines[key] = next < GROUP_PALETTE.length ? GROUP_PALETTE[next] : hashColor(key)
            next++
        }
    }

    // Grupos: orden de "Pedidos por Grupo" (de mayor a menor valor).
    ;(charts.orders_by_line || [])
        .filter(row => Number(row.orders_value) > 0)
        .forEach(row => addLine(lineKey(row.line_id)))

    // Si el rol no ve "Pedidos por Grupo", el orden sale de los grupos de "Pedidos por Familias".
    const familyTotals = {}

    ;(charts.orders_by_family || []).forEach(row => {
        const key = lineKey(row.line_id)
        familyTotals[key] = (familyTotals[key] || 0) + Number(row.orders_value || 0)
    })

    Object.keys(familyTotals)
        .sort((a, b) => familyTotals[b] - familyTotals[a])
        .forEach(addLine)

    // Marcas: el color que ya trae cada recuadro del backend.
    const brandChart = charts.orders_by_brand || {}

    ;(brandChart.tiles || []).forEach(tile => {
        brands[brandKey(tile.brandId, tile.x)] = tile.color
    })

    return { lines, brands }
}
